import { InboxViewOnFetchDataEpic } from './InboxViewOnFetchDataEpic';
import { InboxViewOnInitEpic } from './InboxViewOnInitEpic';
import { InboxViewOnRouteEpic } from './InboxViewOnRouteEpic';

export const rootInboxViewEpics = [
  InboxViewOnInitEpic,
  InboxViewOnRouteEpic,
  InboxViewOnFetchDataEpic,
];
